import React from 'react';
import { CircleCheck, CircleAlert } from 'lucide-react';
import { tieneFactorValidado } from '../utils/finanzas';
import '../styles/FactorBadge.css';

/**
 * Identificación visual obligatoria: distingue productos con cálculo
 * respaldado por evidencia real (internamente, factorPago) de los que
 * todavía dependen de una fórmula no validada.
 */
function FactorBadge({ codigoProducto }) {
  const validado = tieneFactorValidado(codigoProducto);

  if (validado) {
    return (
      <span className="factor-badge is-validado">
        <CircleCheck size={13} strokeWidth={2} />
        Cálculo validado
      </span>
    );
  }

  return (
    <span className="factor-badge is-pendiente">
      <CircleAlert size={13} strokeWidth={2} />
      Pendiente de parametrización
    </span>
  );
}

export default FactorBadge;
